var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _c("p", { staticClass: "text-body header" }, [
        _c("b", [_vm._v("Termos e Condições de Uso")])
      ]),
      _c("p", { staticClass: "text-body" }, [
        _vm._v(
          ' Estes são os Termos e Condições de Uso ("Termos") da plataforma de software ("Plataforma") desenvolvida pela KRISTAL EMPREENDIMENTOS E ASSESSORIA LTDA, pessoa jurídica de direito privado inscrita no CNPJ/MF sob nº 49.200.391/0001-87, com sede na Cidade de Belo Horizonte, Estado de Minas Gerais, na Rua Gonçalves Dias, nº 142, sala 902 B, Funcionários, CEP 31.140-090 (“KRISTAL EMPREENDIMENTOS E ASSESSORIA LTDA”,"KRISTAL", "Nós", "Nossos"), e regulam todas as condições aplicáveis ao uso dos Nossos serviços ("Serviços"). '
        )
      ]),
      _c("p", { staticClass: "text-body" }, [
        _vm._v(
          ' Ao usar nossos Serviços, você ("Você", "Seu", "Usuário") estará sujeito aos presentes Termos. Leia-os com atenção. '
        )
      ]),
      _c("p", { staticClass: "text-body" }, [
        _vm._v(
          " KriCon é um aplicativo desenvolvido para consolidar as aplicações financeiras feitas em várias instituições em um único local, fornecendo uma visão consolidada e comparativa das aplicações financeiras segundo diferentes estratégias de alocação. "
        )
      ]),
      _c("p", { staticClass: "text-body" }, [
        _vm._v(
          " Criada para funcionar como uma solução única e moderna, com foco em escalabilidade, segurança e performance para você, seu acesso e uso ao nosso Site ou à Plataforma KriCon (respectivamente Site e Plataforma) são regidos pelos presentes termos e condições (“Termos de Uso”), em conjunto com nossa Política de Privacidade, que é o documento que regula o tratamento e proteção de seus dados pessoais. "
        )
      ]),
      _c("p", { staticClass: "text-body" }, [
        _vm._v(
          " Nós somos uma plataforma de cálculo, consolidação e controle de carteira on-line. LEIA ATENTAMENTE O PRESENTE DOCUMENTO. SE VOCÊ NÃO CONCORDAR COM QUALQUER CONDIÇÃO DESTES TERMOS OU DE NOSSA POLÍTICA DE PRIVACIDADE, NÃO CLIQUE EM “ACEITO” AO FINAL DO TEXTO. AO ACEITAR, VOCÊ RECONHECE A INTEGRIDADE DESTES TERMOS DE USO, EM CONJUNTO COM NOSSA POLÍTICA DE PRIVACIDADE, E CONSENTE COM O SEU TEOR DE FORMA LIVRE E ESPONTÂNEA. "
        )
      ]),
      _c("ol", [
        _c("li", [
          _c("p", { staticClass: "text-body" }, [_vm._v(" Das Definições ")])
        ])
      ]),
      _c("p", { staticClass: "text-body inset" }, [
        _vm._v(
          " Os termos constantes nestes Termos de Uso, sempre que usados com a primeira letra em maiúsculo, terão o significado estabelecido abaixo, seja no plural ou no singular: "
        )
      ]),
      _c("p", { staticClass: "text-body inset" }, [
        _c("b", [_vm._v("Instituições")]),
        _vm._v(
          " : Bancos, instituições financeiras, seguradoras, corretoras de seguros, agentes reguladores, entre outros. "
        )
      ]),
      _c("p", { staticClass: "text-body inset" }, [
        _c("b", [_vm._v("Aceitar ou Aceite")]),
        _vm._v(
          " : é o ato pelo qual o usuário declara, ao clicar na caixa de diálogo dos Termos de Uso e Política de Privacidade dispostas no Site ou na Plataforma, que leu e aceitou todos os termos e política de privacidade nele previstos. Sendo o ato considerado como um consentimento prévio e expresso em relação a todo o disposto em tais documentos. "
        )
      ]),
      _c("p", { staticClass: "text-body inset" }, [
        _c("b", [_vm._v("Conteúdo")]),
        _vm._v(
          " : significa toda e qualquer informação disponibilizada pelo ou por meio do Site ou da Plataforma, tais como textos, dados, software, imagens, vídeos, áudios, recursos interativos, números, etc., incluindo-se os códigos fontes empregados para exibição desses Conteúdos, como aqueles em linguagem HTML, CSS, PHP, entre outros. "
        )
      ]),
      _c("p", { staticClass: "text-body inset" }, [
        _c("b", [_vm._v("Conta KriCon")]),
        _vm._v(
          " : significa a conta de acesso do Usuário à ferramenta de consolidação de investimentos "
        ),
        _c("b", [_vm._v("KriCon")]),
        _vm._v(". ")
      ]),
      _c("p", { staticClass: "text-body inset" }, [
        _c("b", [_vm._v("Consultores Financeiros")]),
        _vm._v(
          " : significa quaisquer profissionais e consultores financeiros, sejam estes autônomos ou empregados, funcionários ou parceiros de um escritório de investimentos, responsável pela consultoria de investimentos de clientes, que possam auxiliar, aconselhar, prestar informações ou interagir com Usuários no âmbito do Site ou Plataforma. "
        )
      ]),
      _c("p", { staticClass: "text-body inset" }, [
        _c("b", [_vm._v("Dados de Conta")]),
        _vm._v(
          " : significa qualquer informação que o Usuário forneça à KRISTAL EMPREENDIMENTOS E ASSESSORIA LTDA, tais como, mas não se limitando, a dados da instituição financeira, número de agência bancária, número de conta, senha de acesso online da instituição bancária, bem como quaisquer dados de contas correntes, investimentos, imóveis, bens, contas poupança e/ou cartões de crédito dos Usuários. "
        )
      ]),
      _c("p", { staticClass: "text-body inset" }, [
        _c("b", [_vm._v("Dados Financeiros Pessoais")]),
        _vm._v(
          " : significa todos os dados do usuário obtidos pela KRISTAL EMPREENDIMENTOS E ASSESSORIA LTDA diretamente nos sites das Instituições ou junto aos Consultores Financeiros, em relação à situação financeira dos usuários, além de outras necessárias para o exercício das atividades de gerenciamento dos investimentos do Usuário na Conta KriCon. "
        )
      ]),
      _c("p", { staticClass: "text-body inset" }, [
        _c("b", [_vm._v("Dados Pessoais")]),
        _vm._v(
          " : significa qualquer informação que possa identificar o Usuário, bem como qualquer outra pessoa natural, direta ou indiretamente (tais como, mas não se limitando a, nome, endereço, número de telefone, número de fax ou endereço de e-mail, dados relacionados a pagamentos como dados de cartão de crédito e Dados Pessoais Financeiros quando passíveis de identificar o Usuário). "
        )
      ]),
      _c("p", { staticClass: "text-body inset" }, [
        _c("b", [_vm._v("Legislação Aplicável de Proteção de Dados")]),
        _vm._v(
          " : trata-se da Lei Geral de Proteção de Dados Pessoais (Lei Nº 13.709/2018 ou “LGPD”), suas alterações posteriores, e quaisquer outras leis e regulamentos em relação ao Tratamento, proteção e privacidade de Dados Pessoais que sejam aplicáveis e, se aplicáveis, todas as orientações, normas, regras, portarias, regulamentos e códigos de prática e conduta emitidos pela Autoridade Nacional de Proteção de Dados (ANPD) ou outra autoridade de supervisão ou proteção de dados pertinente. "
        )
      ]),
      _c("p", { staticClass: "text-body inset" }, [
        _c("b", [_vm._v("Plataforma")]),
        _vm._v(
          " : significa o software de propriedade exclusiva da KRISTAL EMPREENDIMENTOS E ASSESSORIA LTDA, que utiliza o serviço de parceiros para a coleta e processamento de dados, que possuem políticas de uso e privacidade próprias. Recomendamos que você leia, entenda e concorde com essas políticas antes de aceitar os Serviços. É utilizado o sistema de Open Finance, APIs e outros, para manejar todos os dados dos investimentos e movimentações financeiras do Usuário, sempre de maneira automatizada, por meio da Conta KriCon, e que será acessado pelos Usuários. "
        )
      ]),
      _c("p", { staticClass: "text-body inset emph" }, [
        _vm._v(
          " Política de Privacidade: significa a política de privacidade que rege as disposições sobre a utilização dos dados do Usuário que pode ser encontrada no seguinte link. XXXXXXXXXXXXXX "
        )
      ]),
      _c("p", { staticClass: "text-body inset" }, [
        _c("b", [_vm._v("Site")]),
        _vm._v(
          " : é o endereço eletrônico https://kristalconnect.com.br/kricon/ ou qualquer outro que vier a substituí-lo. "
        )
      ]),
      _c("p", { staticClass: "text-body inset" }, [
        _c("b", [_vm._v("Subscrição")]),
        _vm._v(
          " : significa uma assinatura paga de subscrição que possibilitará ao Usuário ter acesso a funcionalidades exclusivas dentro da Plataforma; "
        )
      ]),
      _c("p", { staticClass: "text-body inset" }, [
        _c("b", [_vm._v("Taxa de Subscrição")]),
        _vm._v(
          " : significa a taxa paga pelo Usuário para contratar uma Subscrição; "
        )
      ]),
      _c("p", { staticClass: "text-body inset" }, [
        _c("b", [_vm._v("Tratamento")]),
        _vm._v(
          " : qualquer operação ou conjunto de operações realizadas com seus Dados Pessoais ou conjuntos de Dados Pessoais, seja por meios automatizados ou não, tais como, mas não se limitando a, coleta, uso, acesso, organização, consulta, produção, alteração, recepção, classificação, utilização, reprodução, comunicação, transmissão, distribuição, processamento, arquivamento, registro, estruturação, armazenamento, adaptação, recuperação, transferência, disponibilização, combinação, restrição, eliminação, avaliação ou controle, modificação, eliminação ou extração. "
        )
      ]),
      _c("p", { staticClass: "text-body inset" }, [
        _c("b", [_vm._v("Usuário")]),
        _vm._v(
          " : significa uma pessoa física, maior de idade, ou jurídica, com plena capacidade de contratar, que busca o auxílio, aconselhamento, informações ou interagir com o Site ou Plataforma e realiza o seu cadastro pessoal de modo a usufruir das funcionalidades oferecidas pela KRISTAL EMPREENDIMENTOS E ASSESSORIA LTDA por meio de sua Conta KriCon, aderindo desta forma automaticamente aos Termos de Uso do Usuário e à nossa Política de Privacidade. "
        )
      ]),
      _c("p", { staticClass: "text-body inset" }, [
        _c("b", [_vm._v("Open Finance")]),
        _vm._v(
          " : o compartilhamento padronizado de dados e serviços por meio de APIs (Application Programming Interfaces) por parte de instituições financeiras e demais instituições autorizadas a funcionar pelo Banco Central do Brasil. No caso de dados de clientes (pessoa física ou jurídica) é o cliente que decidirá quando e com quem ele deseja compartilhá-los no escopo do Open Finance, desde que seja com finalidades específicas e prazos determinados. "
        )
      ]),
      _c("ol", { attrs: { start: "2" } }, [
        _c("li", [
          _c("p", { staticClass: "text-body" }, [_vm._v(" Da Adesão ")])
        ])
      ]),
      _c("p", { staticClass: "text-body inset" }, [
        _vm._v(
          " Para a adesão e utilização das funcionalidades da Plataforma, é obrigatória a leitura, compreensão e Aceite dos presentes Termos de Uso e da Política de Privacidade pelo Usuário. A partir do momento em que o Usuário Aceitar os Termos de Uso e a Política de Privacidade, as regras neles contidas irão regular plenamente a relação entre a KRISTAL EMPREENDIMENTOS E ASSESSORIA LTDA e o Usuário. "
        )
      ]),
      _c("p", { staticClass: "text-body inset" }, [
        _vm._v(
          " Será dever do Usuário manter-se atento a possíveis atualizações dos Termos de Uso e da Política de Privacidade, que podem ocorrer a qualquer tempo. "
        )
      ]),
      _c("ol", { attrs: { start: "3" } }, [
        _c("li", [
          _c("p", { staticClass: "text-body" }, [
            _vm._v(
              " Comunicação com a KRISTAL EMPREENDIMENTOS E ASSESSORIA LTDA "
            )
          ])
        ])
      ]),
      _c("p", { staticClass: "text-body inset" }, [
        _vm._v(
          " Para qualquer questão relacionada a estes Termos de Uso, à Política de Privacidade ou ao uso do Site/Conteúdo/Software, o Usuário deve entrar em contato com a KRISTAL EMPREENDIMENTOS E ASSESSORIA LTDA pelo e-mail contato@kristalconnect.com.br. "
        )
      ]),
      _c("ol", { attrs: { start: "4" } }, [
        _c("li", [
          _c("p", { staticClass: "text-body" }, [
            _vm._v(" Utilização da Plataforma ")
          ])
        ])
      ]),
      _c("p", { staticClass: "text-body inset" }, [
        _vm._v(
          " Estes Termos de Uso concedem ao Usuário uma licença pessoal, mundial, revogável, não exclusiva e intransferível para uso do software relacionado à Plataforma, sem cobrança de royalties. O Usuário não pode utilizar ou permitir o uso deste software para qualquer finalidade não expressamente prevista nestes Termos de Uso. É proibido ao Usuário copiar, modificar, distribuir, vender ou alugar os serviços disponibilizados pela KRISTAL EMPREENDIMENTOS E ASSESSORIA LTDA através da Plataforma. "
        )
      ]),
      _c("p", { staticClass: "text-body inset" }, [
        _vm._v(
          " Ao contratar o aplicativo desenvolvido para consolidar as aplicações financeiras KriCon, o Usuário fornecerá ou permitirá o acesso da KRISTAL EMPREENDIMENTOS E ASSESSORIA LTDA aos seus Dados Pessoais para a criação de um nome de usuário (“Login”) e senha, que serão utilizados para acessar a Conta KriCon do Usuário. "
        )
      ]),
      _c("p", { staticClass: "text-body inset" }, [
        _vm._v(
          " Para usar o Site ou a Plataforma, o Usuário deve ser maior de idade conforme a legislação brasileira e capaz de exercer direitos e deveres de acordo com o Código Civil. É proibido o acesso de menores de 18 anos não emancipados e de incapazes ao Site ou à Plataforma. "
        )
      ]),
      _c("p", { staticClass: "text-body inset" }, [
        _vm._v(
          " O Usuário é responsável pela veracidade, validade e precisão de todos os Dados Pessoais, incluindo Dados de Conta, fornecidos para o cadastro, bem como por manter o cadastro atualizado com um endereço de e-mail válido para medidas de segurança e validação de acesso eventualmente utilizadas pela KRISTAL EMPREENDIMENTOS E ASSESSORIA LTDA. "
        )
      ]),
      _c("p", { staticClass: "text-body inset" }, [
        _vm._v(
          " A KRISTAL EMPREENDIMENTOS E ASSESSORIA LTDA não tem obrigação de policiar, validar ou fiscalizar os Dados Pessoais ou de Conta fornecidos pelos Usuários, mas poderá, a seu critério, excluir informações que pareçam inverídicas, ofensivas ou que possam expor a KRISTAL EMPREENDIMENTOS E ASSESSORIA LTDA, seus parceiros e demais Usuários a riscos. "
        )
      ]),
      _c("p", { staticClass: "text-body inset" }, [
        _vm._v(
          " A senha e o Login criados pelo Usuário para acesso à sua Conta KriCon são confidenciais e de responsabilidade exclusiva do Usuário, que deve entrar em contato com a KRISTAL EMPREENDIMENTOS E ASSESSORIA LTDA imediatamente em caso de comprometimento do sigilo. A KRISTAL EMPREENDIMENTOS E ASSESSORIA LTDA não recomenda o uso da mesma senha para diversos sites ou a inserção de Dados Pessoais ou Dados de Conta como parte da senha. "
        )
      ]),
      _c("p", { staticClass: "text-body inset" }, [
        _vm._v(
          " Ao fornecer seus Dados Pessoais e Dados de Conta à KRISTAL EMPREENDIMENTOS E ASSESSORIA LTDA, o Usuário autoriza a KRISTAL EMPREENDIMENTOS E ASSESSORIA LTDA a utilizar o serviço de parceiros para a coleta e processamento de seus Dados Financeiros Pessoais junto a cada instituição financeira, Consultores Financeiros e/ou corretora informada pelo Usuário. A KRISTAL EMPREENDIMENTOS E ASSESSORIA LTDA utilizará a Plataforma para organizar esses dados, visando a prestação de serviços e oferta de produtos ao Usuário, sempre de acordo com os Termos de Uso, a Legislação Aplicável de Proteção de Dados e a Política de Privacidade. "
        )
      ]),
      _c("p", { staticClass: "text-body inset" }, [
        _vm._v(
          " O uso da Plataforma pelo Usuário é pessoal e intransferível, exclusivamente para fins lícitos relacionados ao propósito da Plataforma, conforme descrito nestes Termos de Uso. Em nenhuma hipótese, o Usuário terá acesso ao código fonte do software que hospeda a Plataforma, de propriedade exclusiva da KRISTAL EMPREENDIMENTOS E ASSESSORIA LTDA. "
        )
      ]),
      _c("ol", { attrs: { start: "5" } }, [
        _c("li", [
          _c("p", { staticClass: "text-body" }, [_vm._v(" Dados de Conta ")])
        ])
      ]),
      _c("p", { staticClass: "text-body inset" }, [
        _vm._v(
          " Para a funcionalidade completa do Site e da Plataforma, o Usuário fará o acesso pessoalmente as suas contas obtendo seus Dados Financeiros Pessoais disponíveis no Open Finance, APIs ou outros disponibilizados pelas Instituições. "
        )
      ]),
      _c("p", { staticClass: "text-body inset" }, [
        _vm._v(
          " Todas as senhas e/ou códigos de autorização, para esta funcionalidade, não serão solicitados pela KRISTAL EMPREENDIMENTOS E ASSESSORIA LTDA. O acesso aos dados disponíveis no Open Finance do Usuário serão utilizados apenas conforme os termos da Política de Privacidade. "
        )
      ]),
      _c("p", { staticClass: "text-body inset" }, [
        _vm._v(
          " A KRISTAL EMPREENDIMENTOS E ASSESSORIA LTDA não se responsabiliza pela revisão, veracidade e integridade dos Dados de Conta fornecidos pelo Usuário, bem como pelos Dados Financeiros Pessoais obtidos nos sites das Instituições ou via Open Finance , no que se refere à precisão dos dados, legalidade ou ameaça de violação devido ao compartilhamento desses dados. "
        )
      ]),
      _c("p", { staticClass: "text-body inset" }, [
        _vm._v(
          " O Usuário reconhece que a KRISTAL EMPREENDIMENTOS E ASSESSORIA LTDA não é uma extensão ou associação das Instituições de onde os Dados Financeiros Pessoais são extraídos, não sendo responsável pelos produtos e/ou serviços oferecidos por eles. "
        )
      ]),
      _c("p", { staticClass: "text-body inset" }, [
        _vm._v(
          " O acesso aos Dados de Conta e aos Dados Financeiros Pessoais do Usuário depende de serviços prestados pelas Instituições. A KRISTAL EMPREENDIMENTOS E ASSESSORIA LTDA não assume responsabilidade quanto à pontualidade, precisão, integridade, não entrega ou falha na obtenção desses dados devido a problemas técnicos ou dificuldades de conexão. "
        )
      ]),
      _c("p", { staticClass: "text-body inset" }, [
        _vm._v(
          " O Usuário concorda em pagar a taxa da Subscrição conforme indicado na Plataforma para utilização da importação automática dos Dados Financeiros Pessoais do Usuário de sua Conta KriCon. "
        )
      ]),
      _c("ol", { attrs: { start: "6" } }, [
        _c("li", [
          _c("p", { staticClass: "text-body" }, [
            _vm._v(" Limitações de Uso e Interferência ")
          ]),
          _c("ol", [
            _c("li", [
              _c("p", { staticClass: "text-body" }, [
                _vm._v(" É vedado ao Usuário: ")
              ]),
              _c("ol", [
                _c("li", [
                  _c("p", { staticClass: "text-body" }, [
                    _vm._v(
                      " - Utilizar o Site ou a Plataforma para divulgar informações que violem normas aplicáveis no Brasil, direitos da KRISTAL EMPREENDIMENTOS E ASSESSORIA LTDA ou de terceiros, incluindo, sem limitação, a violação de direitos de propriedade intelectual, direitos autorais e de privacidade, ou divulgar conteúdo ilegal, imoral, inapropriado ou ofensivo. "
                    )
                  ])
                ]),
                _c("li", [
                  _c("p", { staticClass: "text-body" }, [
                    _vm._v(
                      " - Copiar, ceder, sublicenciar, vender, dar em locação, reproduzir, doar, alienar, transferir, total ou parcialmente, gratuita ou onerosamente, provisória ou permanentemente, o software da Plataforma, assim como seus módulos, partes, manuais ou quaisquer outros direitos de propriedade intelectual da KRISTAL EMPREENDIMENTOS E ASSESSORIA LTDA. "
                    )
                  ])
                ]),
                _c("li", [
                  _c("p", { staticClass: "text-body" }, [
                    _vm._v(
                      " - Promover ou permitir descompilação, desmontagem ou engenharia reversa do software da Plataforma, desenvolver novos softwares ou aplicativos baseados em informações extraídas do Site ou da Plataforma, ou em dados inseridos no Site ou na Plataforma. "
                    )
                  ])
                ]),
                _c("li", [
                  _c("p", { staticClass: "text-body" }, [
                    _vm._v(
                      " - Utilizar softwares, técnicas e/ou artifícios para usar indevidamente o Site, o software ou a Plataforma para práticas nocivas à KRISTAL EMPREENDIMENTOS E ASSESSORIA LTDA ou a terceiros. "
                    )
                  ])
                ]),
                _c("li", [
                  _c("p", { staticClass: "text-body" }, [
                    _vm._v(
                      " - Reproduzir, adaptar, modificar e/ou usar, no todo ou em parte, o software ou qualquer Conteúdo do Site ou da Plataforma sem autorização expressa da KRISTAL EMPREENDIMENTOS E ASSESSORIA LTDA. "
                    )
                  ])
                ]),
                _c("li", [
                  _c("p", { staticClass: "text-body" }, [
                    _vm._v(
                      " - Publicar ou transmitir arquivos que contenham vírus, worms, cavalos de troia ou qualquer outro programa contaminante ou destrutivo, ou que interfiram no bom funcionamento do Site, Plataforma ou software da Plataforma. "
                    )
                  ])
                ]),
                _c("li", [
                  _c("p", { staticClass: "text-body" }, [
                    _vm._v(
                      " - Utilizar o software, Site ou Plataforma para finalidade diversa daquela para a qual foi disponibilizado pela KRISTAL EMPREENDIMENTOS E ASSESSORIA LTDA. "
                    )
                  ])
                ]),
                _c("li", [
                  _c("p", { staticClass: "text-body" }, [
                    _vm._v(
                      " - Divulgar, utilizar ou modificar indevidamente os dados de outros Usuários. "
                    )
                  ])
                ]),
                _c("li", [
                  _c("p", { staticClass: "text-body" }, [
                    _vm._v(
                      " - Permitir o uso não autorizado da Plataforma, do software ou do Site para benefício de terceiros. "
                    )
                  ])
                ])
              ])
            ])
          ])
        ]),
        _c("li", [
          _c("p", { staticClass: "text-body" }, [
            _vm._v(" Política de Privacidade ")
          ])
        ])
      ]),
      _c("p", { staticClass: "text-body inset" }, [
        _vm._v(
          " Ao se cadastrar na KriCon, o Usuário concorda com a Política de Privacidade. O Aceite da Política de Privacidade autoriza a KRISTAL EMPREENDIMENTOS E ASSESSORIA LTDA a usar os Dados Pessoais do Usuário conforme descrito no respectivo documento. "
        )
      ]),
      _c("ol", { attrs: { start: "8" } }, [
        _c("li", [
          _c("p", { staticClass: "text-body" }, [
            _vm._v(" Propriedade Intelectual ")
          ])
        ])
      ]),
      _c("p", { staticClass: "text-body inset" }, [
        _vm._v(
          " Os Usuários não adquirem, por meio destes Termos de Uso ou da Política de Privacidade, nenhum direito de propriedade intelectual sobre os softwares, a Plataforma e/ou o Site, que são de propriedade exclusiva da KRISTAL EMPREENDIMENTOS E ASSESSORIA LTDA. "
        )
      ]),
      _c("p", { staticClass: "text-body inset" }, [
        _vm._v(
          " Caso o Usuário ou qualquer outro venha a desenvolver um novo módulo, aprimoramento, melhoria ou produto semelhante ou complementar aos softwares da KRISTAL EMPREENDIMENTOS E ASSESSORIA LTDA, ao Site ou à Plataforma, todos os direitos de propriedade intelectual serão incorporados pela KRISTAL EMPREENDIMENTOS E ASSESSORIA LTDA, com uso condicionado a estas cláusulas contratuais. O Usuário se compromete a assinar os documentos necessários e fornecer informações solicitadas pela KRISTAL EMPREENDIMENTOS E ASSESSORIA LTDA para formalizar a titularidade desses direitos pela KRISTAL EMPREENDIMENTOS E ASSESSORIA LTDA. "
        )
      ]),
      _c("p", { staticClass: "text-body inset" }, [
        _vm._v(
          " O Usuário está autorizado a fazer download ou imprimir uma cópia das informações, planilhas e gráficos presentes no Site ou na Plataforma para uso pessoal, sendo vedado qualquer outro tipo de uso sem o consentimento prévio e expresso da KRISTAL EMPREENDIMENTOS E ASSESSORIA LTDA. "
        )
      ]),
      _c("p", { staticClass: "text-body inset" }, [
        _vm._v(
          " Todo Conteúdo disponibilizado no Site ou na Plataforma, como textos, gráficos, imagens, logos, ícones, fotografias, conteúdo editorial, notificações, softwares e qualquer outro material, pertence exclusivamente à KRISTAL EMPREENDIMENTOS E ASSESSORIA LTDA e é protegido pela lei brasileira de propriedade intelectual e direitos autorais. "
        )
      ]),
      _c("p", { staticClass: "text-body inset" }, [
        _vm._v(
          " Quanto aos Dados Pessoais, incorporados aos Dados de Conta ou Dados Financeiros Pessoais, o Usuário entende e concorda que a KRISTAL EMPREENDIMENTOS E ASSESSORIA LTDA atuará como seu representante perante os sites das Instituições e Consultores Financeiros. "
        )
      ]),
      _c("p", { staticClass: "text-body inset" }, [
        _vm._v(
          " O aceite dos Termos de Uso e da Política de Privacidade implica no consentimento expresso do Usuário para que a KRISTAL EMPREENDIMENTOS E ASSESSORIA LTDA acesse e utilize seus Dados Pessoais, incluindo Dados de Conta e Dados Financeiros Pessoais fornecidos através desses sites ou inseridos na Plataforma ou no Site. "
        )
      ]),
      _c("p", { staticClass: "text-body inset" }, [
        _vm._v(
          " Caso o Usuário identifique que qualquer conteúdo disponível através da Plataforma ou do Site viola direitos autorais de sua propriedade, deve entrar em contato com a KRISTAL EMPREENDIMENTOS E ASSESSORIA LTDA através do e-mail "
        ),
        _c("u", [
          _c("a", { attrs: { href: "mailto:contato@kristalconnect.com.br" } }, [
            _vm._v(" contato@kristalconnect.com.br")
          ])
        ]),
        _vm._v(". ")
      ]),
      _c("ol", { attrs: { start: "9" } }, [
        _c("li", [
          _c("p", { staticClass: "text-body" }, [
            _vm._v(" Suspensões, Restrições e Modificações no Site ")
          ])
        ])
      ]),
      _c("p", { staticClass: "text-body adjust" }, [
        _vm._v(
          " 9.1 A KRISTAL EMPREENDIMENTOS E ASSESSORIA LTDA reserva-se o direito exclusivo de, a qualquer momento e sem necessidade de aviso prévio ao Usuário: "
        )
      ]),
      _c("p", { staticClass: "text-body adjust" }, [
        _vm._v(
          " 9.1.1 - Encerrar, modificar ou suspender total ou parcialmente o acesso do Usuário ao Site ou à Plataforma, caso o acesso ou uso viole as condições estabelecidas nos Termos de Uso e/ou na Política de Privacidade. "
        )
      ]),
      _c("p", { staticClass: "text-body adjust" }, [
        _vm._v(
          " 9.1.2 - Excluir total ou parcialmente informações cadastradas pelo Usuário que não estejam em conformidade com as disposições dos Termos de Uso. "
        )
      ]),
      _c("p", { staticClass: "text-body adjust" }, [
        _vm._v(
          " 9.1.3 - Adicionar, excluir ou modificar o Conteúdo oferecido pela KRISTAL EMPREENDIMENTOS E ASSESSORIA LTDA, bem como as funcionalidades disponíveis no Site ou Plataforma, com o objetivo de melhorar a qualidade dos serviços prestados. A KRISTAL EMPREENDIMENTOS E ASSESSORIA LTDA não se obriga a manter ativa qualquer funcionalidade ou serviço oferecido anteriormente. "
        )
      ]),
      _c("p", { staticClass: "text-body adjust" }, [
        _vm._v(
          " 9.2 Adicionalmente, a KRISTAL EMPREENDIMENTOS E ASSESSORIA LTDA poderá, a seu critério exclusivo e mediante aviso prévio ao Usuário: "
        )
      ]),
      _c("p", { staticClass: "text-body adjust" }, [
        _vm._v(
          " 9.2.1 - Suspender, modificar ou encerrar as atividades do Site ou da Plataforma, exceto em casos de caso fortuito ou força maior. "
        )
      ]),
      _c("p", { staticClass: "text-body adjust" }, [
        _vm._v(
          " 9.2.2 - Definir preços para determinados conteúdos e/ou serviços, mesmo que inicialmente oferecidos gratuitamente, ou precificar novos ambientes ou funcionalidades. O uso continuado pelo Usuário após o aviso será considerado como concordância com os novos preços. "
        )
      ]),
      _c("p", { staticClass: "text-body adjust" }, [
        _vm._v(
          " 10. A subscrição no KriCon implica na adesão a um plano específico mediante o pagamento das Taxas de Subscrição correspondentes. Essas taxas devem ser quitadas antecipadamente, utilizando cartão de crédito ou outro meio disponível na plataforma, podendo ser mensal, anual ou em outra periodicidade conforme o plano selecionado. "
        )
      ]),
      _c("ol", { attrs: { start: "11" } }, [
        _c("li", [
          _c("p", { staticClass: "text-body" }, [
            _vm._v(
              " A KRISTAL EMPREENDIMENTOS E ASSESSORIA LTDA reserva-se o direito de ajustar as Taxas de Subscrição mediante aviso prévio aos usuários. "
            )
          ])
        ]),
        _c("li", [
          _c("p", { staticClass: "text-body" }, [
            _vm._v(
              " Os planos de Subscrição renovam-se automaticamente ao término de cada período contratado, exceto se houver cancelamento pelo usuário com antecedência. Não há reembolso caso o cancelamento ocorra após a cobrança para o novo período. "
            )
          ])
        ]),
        _c("li", [
          _c("p", { staticClass: "text-body" }, [
            _vm._v(
              " Durante a vigência do plano contratado, é possível migrar entre planos, sem direito a reembolso pelos dias não utilizados. O acesso às funcionalidades é liberado em até 72 horas após confirmação do pagamento. "
            )
          ])
        ]),
        _c("li", [
          _c("p", { staticClass: "text-body" }, [
            _vm._v(
              " A KRISTAL EMPREENDIMENTOS E ASSESSORIA LTDA não assume responsabilidade por decisões financeiras tomadas com base nas informações do site ou plataforma, nem por falhas de segurança não sob seu controle direto. "
            )
          ])
        ]),
        _c("li", [
          _c("p", { staticClass: "text-body" }, [
            _vm._v(
              " Esses Termos de Uso são regidos pelas leis brasileiras, com foro exclusivo na Comarca de Belo Horizonte, e foram atualizados pela última vez em 06 de junho de 2024. "
            )
          ])
        ])
      ]),
      _c("hr"),
      _c("p", { staticClass: "text-body header" }, [
        _c("span", [_vm._v("Política de Privacidade")])
      ]),
      _c("p", { staticClass: "text-body extra" }, [
        _c("span", [
          _vm._v(
            "Na Kristal, a privacidade e segurança são prioridades e nos comprometemos com a transparência do tratamento de dados pessoais dos nossos usuários/clientes. Por isso, esta presente Política de Privacidade estabelece como é feita a coleta, uso e transferência de informações de clientes ou outras pessoas que acessam ou usam nosso Consolidador."
          )
        ])
      ]),
      _c("p", { staticClass: "text-body extra" }, [
        _c("span", [
          _vm._v(
            "Ao utilizar nossos serviços, você entende que coletaremos e usaremos suas informações pessoais nas formas descritas nesta Política, sob as normas da Constituição Federal de 1988 (art. 5º, LXXIX; e o art. 22º, XXX – incluídos pela EC 115/2022), das normas de Proteção de Dados (LGPD, Lei Federal 13.709/2018), das disposições consumeristas da Lei Federal 8078/1990 e as demais normas do ordenamento jurídico brasileiro aplicáveis."
          )
        ])
      ]),
      _c("p", { staticClass: "text-body extra" }, [
        _c("span", [_vm._v(" Dessa forma, a ")]),
        _vm._v("KRISTAL EMPREENDIMENTOS E ASSESSORIA LTDA"),
        _c("span", [
          _vm._v(
            ", doravante denominada simplesmente como “Kristal”, inscrita no CNPJ/MF sob o nº 49.200.391/0001-87, no papel de Controladora de Dados, obriga-se ao disposto na presente Política de Privacidade. "
          )
        ])
      ]),
      _c("br"),
      _c("br"),
      _c("p", { staticClass: "text-body extra" }, [
        _c("span", [
          _vm._v("1. Quais dados coletamos sobre você e para qual finalidade?")
        ])
      ]),
      _c("p", { staticClass: "text-body extra" }, [
        _c("span", [
          _vm._v(
            "Nosso consolidador coleta e utiliza alguns dados pessoais e financeiros seus, de forma a viabilizar a prestação de serviços e aprimorar a experiência de uso."
          )
        ])
      ]),
      _c("p", { staticClass: "text-body extra" }, [
        _c("span", [_vm._v("1.1. Dados pessoais fornecidos pelo titular")])
      ]),
      _c("ul", [
        _c("li", [
          _c("p", { staticClass: "text-body extra" }, [
            _c("span", [
              _vm._v(
                "Dados cadastrais como nome, CPF e comprovante de residência para fins de cadastro."
              )
            ])
          ])
        ])
      ]),
      _c("p", { staticClass: "text-body extra" }, [
        _c("span", [_vm._v("1.2. Dados financeiros coletados automaticamente")])
      ]),
      _c("ul", [
        _c("li", [
          _c("p", { staticClass: "text-body extra" }, [
            _c("span", [
              _vm._v(
                "Dados financeiros como investimentos em instituições financeiras reguladas pelo Banco Central do Brasil "
              )
            ])
          ])
        ])
      ]),
      _c("p", { staticClass: "text-body extra" }, [
        _c("span", [_vm._v("2. Como coletamos os seus dados?")])
      ]),
      _c("ul", [
        _c("li", [
          _c("p", { staticClass: "text-body extra" }, [
            _c("span", [
              _vm._v(
                "Os dados serão coletados automaticamente através do “open finance” pela “Instituição transmissora/receptora de dados” para fins de consolidação dos investimentos."
              )
            ])
          ])
        ])
      ]),
      _c("p", { staticClass: "text-body extra" }, [
        _c("span", [_vm._v("2.1. Consentimento")])
      ]),
      _c("ul", [
        _c("li", [
          _c("p", { staticClass: "text-body extra" }, [
            _c("span", [
              _vm._v(
                "O seu consentimento é dado para a instituição de origem dos dados. O consentimento é a manifestação livre, informada e inequívoca pela qual você autoriza a “Instituição transmissora/receptora de dados” a coletar seus dados e transferir para a Kristal onde iremos consolidar os dados no consolidador KriCon."
              )
            ])
          ])
        ])
      ]),
      _c("p", { staticClass: "text-body extra" }, [
        _c("span", [
          _vm._v(
            "Assim, em consonância com a Lei Geral de Proteção de Dados, seus dados só serão coletados, tratados e armazenados mediante prévio e expresso consentimento. "
          )
        ])
      ]),
      _c("p", { staticClass: "text-body extra" }, [
        _c("span", [
          _vm._v(
            " O seu consentimento será obtido de forma específica para cada finalidade acima descrita, evidenciando o compromisso de transparência e boa-fé da "
          )
        ]),
        _vm._v(" KRISTAL EMPREENDIMENTOS E ASSESSORIA LTDA "),
        _c("span", [
          _vm._v(
            " para com seus usuários/clientes, seguindo as regulações legislativas pertinentes. "
          )
        ])
      ]),
      _c("p", { staticClass: "text-body extra" }, [
        _c("span", [_vm._v("Ao utilizar os serviços da ")]),
        _vm._v("KRISTAL EMPREENDIMENTOS E ASSESSORIA LTDA"),
        _c("span", [
          _vm._v(
            " e fornecer seus dados pessoais, você está ciente e consentindo com as disposições desta Política de Privacidade, além de conhecer seus direitos e como exercê-los."
          )
        ])
      ]),
      _c("p", { staticClass: "text-body extra" }, [
        _c("span", [
          _vm._v(
            "A qualquer tempo e sem nenhum custo, você poderá revogar seu consentimento."
          )
        ])
      ]),
      _c("p", { staticClass: "text-body extra" }, [
        _c("span", [
          _vm._v(
            "É importante destacar que a revogação do consentimento para o tratamento dos dados pode implicar a impossibilidade da performance adequada de alguma funcionalidade do site que dependa da operação. Tais consequências serão informadas previamente."
          )
        ])
      ]),
      _c("p", { staticClass: "text-body extra" }, [
        _c("span", [_vm._v("3. Quais são os seus direitos?")])
      ]),
      _c("p", { staticClass: "text-body extra" }, [
        _c("span", [_vm._v("A ")]),
        _vm._v("KRISTAL EMPREENDIMENTOS E ASSESSORIA LTDA"),
        _c("span", [
          _vm._v(
            " assegura a seus usuários/clientes seus direitos de titular previstos no artigo 18 da Lei Geral de Proteção de Dados. Dessa forma, você pode, de maneira gratuita e a qualquer tempo:"
          )
        ])
      ]),
      _c("p", { staticClass: "text-body extra" }, [
        _c("span", [
          _vm._v(
            "Confirmar a existência de tratamento de dados, de maneira simplificada ou em formato claro e completo."
          )
        ])
      ]),
      _c("p", { staticClass: "text-body extra" }, [
        _c("span", [
          _vm._v(
            "Acessar seus dados, podendo solicitá-los em uma cópia legível sob forma impressa ou por meio eletrônico, seguro e idôneo."
          )
        ])
      ]),
      _c("p", { staticClass: "text-body extra" }, [
        _c("span", [
          _vm._v(
            "Corrigir seus dados, ao solicitar a edição, correção ou atualização destes."
          )
        ])
      ]),
      _c("p", { staticClass: "text-body extra" }, [
        _c("span", [
          _vm._v(
            "Limitar seus dados quando desnecessários, excessivos ou tratados em desconformidade com a legislação através da anonimização, bloqueio ou eliminação."
          )
        ])
      ]),
      _c("p", { staticClass: "text-body extra" }, [
        _c("span", [
          _vm._v(
            "Solicitar a portabilidade de seus dados, através de um relatório de dados cadastrais que a "
          )
        ]),
        _vm._v("KRISTAL EMPREENDIMENTOS E ASSESSORIA LTDA"),
        _c("span", [_vm._v(" trata a seu respeito.")])
      ]),
      _c("p", { staticClass: "text-body extra" }, [
        _c("span", [
          _vm._v(
            "Eliminar seus dados tratados a partir de seu consentimento, exceto nos casos previstos em lei."
          )
        ])
      ]),
      _c("p", { staticClass: "text-body extra" }, [
        _c("span", [
          _vm._v(
            "Revogar seu consentimento, desautorizando o tratamento de seus dados."
          )
        ])
      ]),
      _c("p", { staticClass: "text-body extra" }, [
        _c("span", [
          _vm._v(
            "Informar-se sobre a possibilidade de não fornecer seu consentimento e sobre as consequências da negativa."
          )
        ])
      ]),
      _c("p", { staticClass: "text-body extra" }, [
        _c("span", [
          _vm._v("4. Como você pode exercer seus direitos de titular?")
        ])
      ]),
      _c("p", { staticClass: "text-body extra" }, [
        _c("span", [
          _vm._v(
            "Para exercer seus direitos de titular, você deve entrar em contato com a "
          )
        ]),
        _vm._v("KRISTAL EMPREENDIMENTOS E ASSESSORIA LTDA"),
        _c("span", [_vm._v(" através dos seguintes meios disponíveis:")])
      ]),
      _c("p", { staticClass: "text-body extra" }, [
        _c("span", [_vm._v("contato@kricom.com.br")])
      ]),
      _c("p", { staticClass: "text-body extra" }, [
        _c("span", [
          _vm._v(
            "De forma a garantir a sua correta identificação como titular dos dados pessoais objeto da solicitação, é possível que solicitemos documentos ou demais comprovações que possam comprovar sua identidade. Nessa hipótese, você será informado previamente."
          )
        ])
      ]),
      _c("p", { staticClass: "text-body extra" }, [
        _c("span", [
          _vm._v("5. Como e por quanto tempo seus dados serão armazenados?")
        ])
      ]),
      _c("p", { staticClass: "text-body extra" }, [
        _c("span", [_vm._v("Seus dados pessoais coletados pela ")]),
        _vm._v("KRISTAL EMPREENDIMENTOS E ASSESSORIA LTDA"),
        _c("span", [
          _vm._v(
            " serão utilizados e armazenados durante o tempo necessário para a prestação do serviço ou para que as finalidades elencadas na presente Política de Privacidade sejam atingidas, considerando os direitos dos titulares dos dados e dos controladores."
          )
        ])
      ]),
      _c("br"),
      _c("br"),
      _c("p", { staticClass: "text-body extra" }, [
        _c("span", [
          _vm._v(
            "De modo geral, seus dados serão mantidos enquanto a relação contratual entre você e a "
          )
        ]),
        _vm._v("KRISTAL EMPREENDIMENTOS E ASSESSORIA LTDA"),
        _c("span", [
          _vm._v(
            " perdurar. Findado o período de armazenamento dos dados pessoais, estes serão excluídos de nossas bases de dados ou anonimizados, ressalvadas as hipóteses legalmente previstas no artigo 16 lei geral de proteção de dados, a saber:"
          )
        ])
      ]),
      _c("p", { staticClass: "text-body extra" }, [
        _c("span", [
          _vm._v(
            "I – cumprimento de obrigação legal ou regulatória pelo controlador;"
          )
        ])
      ]),
      _c("p", { staticClass: "text-body extra" }, [
        _c("span", [
          _vm._v(
            "II – estudo por órgão de pesquisa, garantida, sempre que possível, a anonimização dos dados pessoais;"
          )
        ])
      ]),
      _c("p", { staticClass: "text-body extra" }, [
        _c("span", [
          _vm._v(
            "III – transferência a terceiro, desde que respeitados os requisitos de tratamento de dados dispostos nesta Lei; ou"
          )
        ])
      ]),
      _c("p", { staticClass: "text-body extra" }, [
        _c("span", [
          _vm._v(
            "IV – uso exclusivo do controlador, vedado seu acesso por terceiro, e desde que anonimizados os dados."
          )
        ])
      ]),
      _c("p", { staticClass: "text-body extra" }, [
        _c("span", [
          _vm._v(
            "Isto é, informações pessoais sobre você que sejam imprescindíveis para o cumprimento de determinações legais, judiciais e administrativas e/ou para o exercício do direito de defesa em processos judiciais e administrativos serão mantidas, a despeito da exclusão dos demais dados. "
          )
        ])
      ]),
      _c("p", { staticClass: "text-body extra" }, [
        _c("span", [
          _vm._v(
            "O armazenamento de dados coletados pela KriCon reflete o nosso compromisso com a segurança e privacidade dos seus dados. Empregamos medidas e soluções técnicas de proteção aptas a garantir a confidencialidade, integridade e inviolabilidade dos seus dados. Além disso, também contamos com medidas de segurança apropriadas aos riscos e com controle de acesso às informações armazenadas."
          )
        ])
      ]),
      _c("p", { staticClass: "text-body extra" }, [
        _c("span", [_vm._v("6. O que fazemos para manter seus dados seguros?")])
      ]),
      _c("p", { staticClass: "text-body extra" }, [
        _c("span", [
          _vm._v(
            "Para mantermos suas informações pessoais seguras, usamos ferramentas físicas, eletrônicas e gerenciais orientadas para a proteção da sua privacidade."
          )
        ])
      ]),
      _c("p", { staticClass: "text-body extra" }, [
        _c("span", [
          _vm._v(
            "Aplicamos essas ferramentas levando em consideração a natureza dos dados pessoais coletados, o contexto e a finalidade do tratamento e os riscos que eventuais violações gerariam para os direitos e liberdades do titular dos dados coletados e tratados."
          )
        ])
      ]),
      _c("p", { staticClass: "text-body extra" }, [
        _c("span", [
          _vm._v("Apenas pessoas autorizadas têm acesso a seus dados pessoais")
        ])
      ]),
      _c("p", { staticClass: "text-body extra" }, [
        _c("span", [
          _vm._v(
            "O acesso a seus dados pessoais é feito somente após o compromisso de confidencialidade"
          )
        ])
      ]),
      _c("p", { staticClass: "text-body extra" }, [
        _c("span", [
          _vm._v(
            "Seus dados pessoais são armazenados em ambiente seguro e idôneo."
          )
        ])
      ]),
      _c("p", { staticClass: "text-body extra" }, [
        _c("span", [_vm._v("A ")]),
        _vm._v("KRISTAL EMPREENDIMENTOS E ASSESSORIA LTDA"),
        _c("span", [
          _vm._v(
            " se compromete a adotar as melhores posturas para evitar incidentes de segurança. Contudo, é necessário destacar que nenhuma página virtual é inteiramente segura e livre de riscos. É possível que, apesar de todos os nossos protocolos de segurança, problemas de culpa exclusivamente de terceiros ocorram, como ataques cibernéticos de hackers, ou também em decorrência da negligência ou imprudência do próprio usuário/cliente."
          )
        ])
      ]),
      _c("p", { staticClass: "text-body extra" }, [
        _c("span", [
          _vm._v(
            "Em caso de incidentes de segurança que possa gerar risco ou dano relevante para você ou qualquer um de nossos usuários/clientes, comunicaremos aos afetados e a Autoridade Nacional de Proteção de Dados sobre o ocorrido, em consonância com as disposições da Lei Geral de Proteção de Dados."
          )
        ])
      ]),
      _c("br"),
      _c("br"),
      _c("br"),
      _c("br"),
      _c("p", { staticClass: "text-body extra" }, [
        _c("span", [_vm._v("7. Com quem seus dados podem ser compartilhados?")])
      ]),
      _c("p", { staticClass: "text-body extra" }, [
        _c("span", [
          _vm._v("Tendo em vista a preservação de sua privacidade, ")
        ]),
        _vm._v("KRISTAL EMPREENDIMENTOS E ASSESSORIA LTDA"),
        _c("span", [
          _vm._v(
            " não compartilhará seus dados pessoais com nenhum terceiro não autorizado. "
          )
        ])
      ]),
      _c("p", { staticClass: "text-body extra" }, [
        _c("span", [
          _vm._v(
            "Além disso, também existem outras hipóteses em que seus dados poderão ser compartilhados, que são:"
          )
        ])
      ]),
      _c("p", { staticClass: "text-body extra" }, [
        _c("span", [
          _vm._v(
            "I – Determinação legal, requerimento, requisição ou ordem judicial, com autoridades judiciais, administrativas ou governamentais competentes."
          )
        ])
      ]),
      _c("p", { staticClass: "text-body extra" }, [
        _c("span", [
          _vm._v(
            "II – Caso de movimentações societárias, como fusão, aquisição e incorporação, de forma automática"
          )
        ])
      ]),
      _c("p", { staticClass: "text-body extra" }, [
        _c("span", [
          _vm._v(
            "III – Proteção dos direitos da KriCon em qualquer tipo de conflito, inclusive os de teor judicial."
          )
        ])
      ]),
      _c("p", { staticClass: "text-body extra" }, [
        _c("span", [_vm._v("8. Alteração desta Política de Privacidade")])
      ]),
      _c("p", { staticClass: "text-body extra" }, [
        _c("span", [
          _vm._v(
            "A atual versão da Política de Privacidade foi formulada e atualizada pela última vez em: 01 de Junho de 2024."
          )
        ])
      ]),
      _c("p", { staticClass: "text-body extra" }, [
        _c("span", [
          _vm._v(
            "Reservamos o direito de modificar essa Política de Privacidade a qualquer tempo, principalmente em função da adequação a eventuais alterações feitas em nosso site ou em âmbito legislativo. Recomendamos que você a revise com frequência."
          )
        ])
      ]),
      _c("p", { staticClass: "text-body extra" }, [
        _c("span", [
          _vm._v(
            "Eventuais alterações entrarão em vigor a partir de sua publicação em nosso site e sempre lhe notificaremos acerca das mudanças ocorridas."
          )
        ])
      ]),
      _c("p", { staticClass: "text-body extra" }, [
        _c("span", [
          _vm._v(
            "Ao utilizar nossos serviços e fornecer seus dados pessoais após tais modificações, você as consente. "
          )
        ])
      ]),
      _c("p", { staticClass: "text-body extra" }, [
        _c("span", [_vm._v("9. Responsabilidade")])
      ]),
      _c("p", { staticClass: "text-body extra" }, [
        _c("span", [_vm._v("A ")]),
        _vm._v("KRISTAL EMPREENDIMENTOS E ASSESSORIA LTDA"),
        _c("span", [
          _vm._v(
            " prevê a responsabilidade dos agentes que atuam nos processos de tratamento de dados, em conformidade com os artigos 42 ao 45 da Lei Geral de Proteção de Dados."
          )
        ])
      ]),
      _c("p", { staticClass: "text-body extra" }, [
        _c("span", [
          _vm._v(
            "Nos comprometemos em manter esta Política de Privacidade atualizada, observando suas disposições e zelando por seu cumprimento."
          )
        ])
      ]),
      _c("p", { staticClass: "text-body extra" }, [
        _c("span", [
          _vm._v(
            "Além disso, também assumimos o compromisso de buscar condições técnicas e organizativas seguramente aptas a proteger todo o processo de tratamento de dados."
          )
        ])
      ]),
      _c("p", { staticClass: "text-body extra" }, [
        _c("span", [
          _vm._v(
            "Caso a Autoridade Nacional de Proteção de Dados exija a adoção de providências em relação ao tratamento de dados realizado pela KriCon, comprometemo-nos a segui-las. "
          )
        ])
      ]),
      _c("p", { staticClass: "text-body extra" }, [
        _c("span", [_vm._v("10. Isenção de responsabilidade")])
      ]),
      _c("p", { staticClass: "text-body extra" }, [
        _c("span", [
          _vm._v(
            "Conforme mencionado no Tópico 6, embora adotemos elevados padrões de segurança a fim de evitar incidentes, não há nenhuma página virtual inteiramente livre de riscos. Nesse sentido, a "
          )
        ]),
        _vm._v("KRISTAL EMPREENDIMENTOS E ASSESSORIA LTDA"),
        _c("span", [_vm._v(" não se responsabiliza por:")])
      ]),
      _c("p", { staticClass: "text-body extra" }, [
        _c("span", [
          _vm._v(
            "I – Quaisquer consequências decorrentes da negligência, imprudência ou imperícia dos usuários em relação a seus dados individuais. Garantimos e nos responsabilizamos apenas pela segurança dos processos de tratamento de dados e do cumprimento das finalidades descritas no presente instrumento."
          )
        ])
      ]),
      _c("p", { staticClass: "text-body extra" }, [
        _c("span", [
          _vm._v(
            "Destacamos que a responsabilidade em relação à confidencialidade dos dados de acesso é do usuário."
          )
        ])
      ]),
      _c("p", { staticClass: "text-body extra" }, [
        _c("span", [
          _vm._v(
            "II – Ações maliciosas de terceiros, como ataques de hackers, exceto se comprovada conduta culposa ou deliberada da KriCon."
          )
        ])
      ]),
      _c("p", { staticClass: "text-body extra" }, [
        _c("span", [
          _vm._v(
            "Destacamos que em caso de incidentes de segurança que possam gerar risco ou dano relevante para você ou qualquer um de nossos usuários/clientes, comunicaremos aos afetados e a Autoridade Nacional de Proteção de Dados sobre o ocorrido e cumpriremos as providências necessárias."
          )
        ])
      ]),
      _c("p", { staticClass: "text-body extra" }, [
        _c("span", [
          _vm._v(
            "III – Inveracidade das informações inseridas pelo usuário/cliente nos registros necessários para a utilização dos serviços da KriCon; quaisquer consequências decorrentes de informações falsas ou inseridas de má-fé são de inteiramente responsabilidade do usuário/cliente."
          )
        ])
      ]),
      _c("p", { staticClass: "text-body extra" }, [
        _c("span", [_vm._v("11. Encarregado de Proteção de Dados")])
      ]),
      _c("p", { staticClass: "text-body extra" }, [
        _c("span", [
          _vm._v(
            "A KriCon disponibiliza os seguintes meios para que você possa entrar em contato conosco para exercer seus direitos de titular: "
          )
        ])
      ]),
      _c("p", { staticClass: "text-body extra" }, [
        _c("span", [_vm._v("contato@kricon.com.br")])
      ]),
      !_vm.previous
        ? _c(
            "v-form",
            [
              _vm.loading
                ? _c(
                    "v-row",
                    { staticClass: "justify-center align-center" },
                    [
                      _c("v-progress-circular", {
                        attrs: { size: 35, color: "primary", indeterminate: "" }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "v-row",
                { staticClass: "form-controls" },
                [
                  _c(
                    "v-col",
                    [
                      _c("v-checkbox", {
                        attrs: {
                          label:
                            "Concordo e aceito os termos especificados acima."
                        },
                        model: {
                          value: _vm.agree,
                          callback: function($$v) {
                            _vm.agree = $$v
                          },
                          expression: "agree"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { staticClass: "text-center align-content-center" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "d-print-block",
                          attrs: { disabled: !_vm.agree },
                          on: { click: _vm.acceptTerms }
                        },
                        [_vm._v("Aceitar")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { staticClass: "text-center align-content-center" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "d-print-block",
                          on: { click: _vm.getOut }
                        },
                        [_vm._v("Cancelar")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.previous
        ? _c("p", [
            _c("a", { attrs: { href: "#" }, on: { click: _vm.getOut } }, [
              _vm._v("Voltar")
            ])
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }